import { httpAnalytics } from "api/admin/stats";
import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import Search from "components/ui/Search";
import Toggle from "components/ui/Toggle";
import { DateTime } from "luxon";
import { useState } from "react";
import { useQuery } from "react-query";
import currency, { moneyFormat } from "utilities/currency";
import { cryptos } from "utilities/wallets";

const RevenueAnalytics: React.FC = () => {
  const type = "revenue";

  const [value, setValue] = useState("General Analytics");

  const [date, setDate] = useState(DateTime.local().toISODate());

  const manageWhich = value
    .replace("General Analytics", "general")
    .replace("Buy & sell profits", "market");

  const {
    data: { deposit, withdrawal, swap, otc, virtualCard, ...other },
  } = useQuery(
    ["deposits", type, value, date],
    () => httpAnalytics(type, manageWhich, date),
    {
      initialData: {
        deposit: 0,
        withdrawal: 0,
        swap: 0,
        otc: 0,
        virtualCard: 0,
      },
    },
  );

  return (
    <Container>
      <AdminSidebar />
      <Main className="mx-5 mt-5 mb-10 text-left">
        <div className="flex items-center justify-between w-full">
          <h3 className="text-2xl">Revenue analytics</h3>
          <div className="w-3/6">
            <Search type="user" />
          </div>
        </div>

        <div className="my-10">
          <Toggle
            data={["General Analytics", "Buy & sell profits"]}
            value={value}
            setValue={setValue}
          />
        </div>

        <div>
          <span className="ml-5 text-sm">Filter by date:</span>
          <input
            type="date"
            className="py-1 ml-2 border-gray-400 rounded"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="flex flex-wrap mt-20 gap-y-14">
          {value === "General Analytics" && (
            <>
              <div className="w-4/12 rounded-lg">
                <h4 className="mb-2 text-sm font-light">Total deposit fee</h4>
                <p className="text-2xl font-medium">
                  <span className="text-2xl">{currency("ngn")}</span>{" "}
                  {`${moneyFormat(deposit)}`}
                </p>
              </div>
              <div className="w-4/12 rounded-lg">
                <h4 className="mb-2 text-sm font-light">
                  Total withdrawal fee
                </h4>
                <p className="text-2xl font-medium">
                  <span className="text-2xl">{currency("ngn")}</span>{" "}
                  {`${moneyFormat(withdrawal)}`}
                </p>
              </div>
              <div className="w-4/12 rounded-lg">
                <h4 className="mb-2 text-sm font-light">Total swap fee</h4>
                <p className="text-2xl font-medium">
                  <span className="text-2xl">{currency("ngn")}</span>{" "}
                  {`${moneyFormat(swap)}`}
                </p>
              </div>
              <div className="w-4/12 rounded-lg">
                <h4 className="mb-2 text-sm font-light">Total OTC profit</h4>
                <p className="text-2xl font-medium">
                  <span className="text-2xl">{currency("ngn")}</span>{" "}
                  {`${moneyFormat(otc)}`}
                </p>
              </div>
              <div className="w-4/12 rounded-lg">
                <h4 className="mb-2 text-sm font-light">
                  Virtual card fee revenue
                </h4>
                <p className="text-2xl font-medium">
                  <span className="text-2xl">{currency("ngn")}</span>{" "}
                  {`${moneyFormat(virtualCard)}`}
                </p>
              </div>
            </>
          )}

          {value === "Buy & sell profits" && (
            <div>
              <div className="flex flex-wrap items-center w-full mt-2">
                {cryptos?.map((crypto, index) => (
                  <div
                    key={crypto}
                    className="px-8 py-8 border-b-2 odd:border-r odd:border-r-orange-100 border-b-orange-50"
                  >
                    <div className="flex items-center justify-between w-full">
                      <h4 className="font-bold">{crypto.toUpperCase()}</h4>
                      <i className="p-1 rounded fa fa-bitcoin bg-orange-50"></i>
                    </div>
                    <div className="flex flex-wrap gap-y-5">
                      <div className="w-6/12 rounded-lg">
                        <h4 className="mb-2 text-sm font-light">
                          Average Buy Price
                        </h4>
                        <p className="text-xl font-medium">
                          {currency("ngn")}{" "}
                          {`${moneyFormat(
                            other?.[crypto]?.["averageBuy"] || 0,
                          )}`}
                        </p>
                      </div>
                      <div className="w-6/12 rounded-lg">
                        <h4 className="mb-2 text-sm font-light">
                          Average Sell Price
                        </h4>
                        <p className="text-xl font-medium">
                          {currency("ngn")}{" "}
                          {`${moneyFormat(
                            other?.[crypto]?.["averageSell"] || 0,
                          )}`}
                        </p>
                      </div>
                      <div className="w-6/12 rounded-lg">
                        <h4 className="mb-2 text-sm font-light">Profit</h4>
                        <p className="text-xl font-medium">
                          {currency("ngn")}{" "}
                          {`${moneyFormat(other?.[crypto]?.["profit"] || 0)}`}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Main>
    </Container>
  );
};
export default RevenueAnalytics;
